import ScrollHint from 'scroll-hint';
import './vendor.css';
import './styles.css';

const SCROLL_HINT_SELECTOR = '.js-scrollable';
const BOUND_KEY = 'true';

let initialized = false;
let observer: IntersectionObserver | null = null;

export function initScrollHint(): void {
    if (initialized) return;
    initialized = true;
    document.addEventListener('ui:update', () => {
        // root 要素が Turbo で置き換わる可能性があるため observer をリセット
        observer?.disconnect();
        observer = null;
        mount(document);
    });
}

function getObserver(): IntersectionObserver {
    if (!observer) {
        observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (!entry.target.classList.contains('is-scrollable')) return;
                const icon = entry.target.querySelector('.scroll-hint-icon-wrap');
                if (!icon) return;
                if (entry.isIntersecting) {
                    icon.classList.add('is-active');
                    setTimeout(() => icon.classList.add('is-done'), 1200 * 2 + 100);
                    obs.unobserve(entry.target);
                }
            });
        }, {
            root: document.querySelector('#main'),
            threshold: 0.5,
        });
    }
    return observer;
}

function mount(scope: ParentNode): void {
    const elements = Array.from(scope.querySelectorAll<HTMLElement>(SCROLL_HINT_SELECTOR));

    elements.forEach((el) => {
        if (el.dataset.scrollHintBound === BOUND_KEY) return;
        el.dataset.scrollHintBound = BOUND_KEY;

        const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        new ScrollHint(el, {
            suggestiveShadow: true,
            i18n: {
                scrollable: isDesktop ? 'SCROLL' : 'SWIPE',
            },
        });

        getObserver().observe(el);

        el.addEventListener('scroll', () => {
            const icon = el.querySelector<HTMLElement>('.scroll-hint-icon-wrap');
            if (icon) icon.classList.add('is-scrolled');
        }, { once: true, passive: true });
    });
}
